import React from 'react';
import PropTypes from 'prop-types';
import { Dthc } from '../../../Modules';
import { Button, Grid } from 'semantic-ui-react';
import SignatureBlockShow from './SignatureBlockShow';
import SignatureBlockEditDesktop from './SignatureBlockEditDesktop';
import SignatureBlockEditMobile from './SignatureBlockEditMobile';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

const SignatureBlocks = ({
  addSignatureBlock,
  deleteBlock,
  closeNewSignatureBlockEditor,
  createSignatureBlock,
  editingNewSignatureBlock,
  isTemplate,
  localSignatureBlocks,
  newSignatureBlock,
  newSignatureBlockChangeHandler,
  onChange,
  openSignModal,
  readOnly,
  reset,
  resetAddSignatureBlock,
  signatureBlocks,
  signer,
  update
}) => (
  <div>
    {signatureBlocks.length === 0 &&
      !newSignatureBlock &&
      !readOnly &&
      <div style={{ textAlign: 'center', padding: '2em' }}>
        <h4>This contract requires no signatures</h4>
        <br />
        <Button primary onClick={addSignatureBlock}>
          + Add Signature Block
        </Button>
      </div>}
    <Grid stackable>
      {readOnly &&
        <Grid.Row columns={2}>
          {signatureBlocks.map((signatureBlock, idx) => (
            <Grid.Column style={{ paddingBottom: '2em' }} key={signatureBlock.node.id}>
              <SignatureBlockShow
                key={signatureBlock.id || idx}
                signatureBlock={signatureBlock}
                isSigner={signer && signer.id === signatureBlock.node.id}
                openSignModal={openSignModal}
              />
            </Grid.Column>
          ))}
        </Grid.Row>
      }
      {!readOnly &&
        <Grid.Row columns={2}>
          {signatureBlocks.map((signatureBlock, idx) => (
            <Grid.Column style={{ paddingBottom: '2em' }} key={signatureBlock.node.id || idx}>
              <Dthc
                localSignatureBlock={localSignatureBlocks[idx].node}
                onChange={block => {
                  onChange(block, idx);
                }}
                commitUpdate={update}
                desktop={SignatureBlockEditDesktop}
                mobile={SignatureBlockEditMobile}
                reset={reset}
                delete={deleteBlock}
                index={idx}
                isTemplate={isTemplate}
              >
                <SignatureBlockShow
                  signatureBlock={signatureBlock}
                  isTemplate={isTemplate}
                />
              </Dthc>
            </Grid.Column>
          ))}
          <Grid.Column style={{ paddingBottom: '2em' }}>
            <ReactCSSTransitionGroup
              transitionName='slide'
              transitionEnterTimeout={300}
              transitionLeaveTimeout={300}
            >
              {newSignatureBlock && editingNewSignatureBlock &&
                <Dthc
                  localSignatureBlock={newSignatureBlock.node}
                  onChange={block => {
                    newSignatureBlockChangeHandler(block);
                  }}
                  commitUpdate={createSignatureBlock}
                  desktop={SignatureBlockEditDesktop}
                  mobile={SignatureBlockEditMobile}
                  reset={resetAddSignatureBlock}
                  isNew
                  initiallyOpen
                  delete={resetAddSignatureBlock}
                  closeEditor={closeNewSignatureBlockEditor}
                  editorOpen={editingNewSignatureBlock}
                  isTemplate={isTemplate}
                >
                  <div></div>
                </Dthc>
              }
            </ReactCSSTransitionGroup>
          </Grid.Column>
        </Grid.Row>
      }
      <Grid.Row columns='equal'>
        <Grid.Column>
          {signatureBlocks.length > 0 && !editingNewSignatureBlock &&
            !readOnly &&
            <a onClick={addSignatureBlock}>+ Add Signature Block</a>
          }
        </Grid.Column>
      </Grid.Row>
    </Grid>
  </div>
);

SignatureBlocks.propTypes = {
  addSignatureBlock: PropTypes.func.isRequired,
  closeNewSignatureBlockEditor: PropTypes.func.isRequired,
  createSignatureBlock: PropTypes.func.isRequired,
  deleteBlock: PropTypes.func.isRequired,
  editingNewSignatureBlock: PropTypes.bool,
  isTemplate: PropTypes.bool,
  localSignatureBlocks: PropTypes.array.isRequired,
  newSignatureBlock: PropTypes.object,
  newSignatureBlockChangeHandler: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  openSignModal: PropTypes.func,
  readOnly: PropTypes.bool,
  reset: PropTypes.func.isRequired,
  resetAddSignatureBlock: PropTypes.func.isRequired,
  signatureBlocks: PropTypes.array.isRequired,
  signer: PropTypes.object,
  update: PropTypes.func.isRequired
};

export default SignatureBlocks;



// WEBPACK FOOTER //
// ./webpack/components/Document/Sections/SignatureBlocks/SignatureBlocks.js